import { render, staticRenderFns } from "./registrationSuccess.vue?vue&type=template&id=2ff8b0e1&scoped=true"
import script from "./registrationSuccess.vue?vue&type=script&lang=js"
export * from "./registrationSuccess.vue?vue&type=script&lang=js"
import style0 from "./registrationSuccess.vue?vue&type=style&index=0&id=2ff8b0e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8b0e1",
  null
  
)

export default component.exports